/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SteamNewsItem
 */
export interface SteamNewsItem {
    /**
     * 
     * @type {string}
     * @memberof SteamNewsItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SteamNewsItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SteamNewsItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof SteamNewsItem
     */
    author?: string;
    /**
     * Body text, truncated by Steam. May contain BBCode.
     * @type {string}
     * @memberof SteamNewsItem
     */
    contents: string;
    /**
     * Seconds since epoch, as Steam reports it.
     * @type {number}
     * @memberof SteamNewsItem
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof SteamNewsItem
     */
    feedLabel?: string;
    /**
     * The post's lead image, lifted out of its BBCode body. Absent when the post embeds none.
     * @type {string}
     * @memberof SteamNewsItem
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the SteamNewsItem interface.
 */
export function instanceOfSteamNewsItem(value: object): value is SteamNewsItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('contents' in value) || value['contents'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function SteamNewsItemFromJSON(json: any): SteamNewsItem {
    return SteamNewsItemFromJSONTyped(json, false);
}

export function SteamNewsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SteamNewsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'author': json['author'] == null ? undefined : json['author'],
        'contents': json['contents'],
        'date': json['date'],
        'feedLabel': json['feedLabel'] == null ? undefined : json['feedLabel'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function SteamNewsItemToJSON(json: any): SteamNewsItem {
    return SteamNewsItemToJSONTyped(json, false);
}

export function SteamNewsItemToJSONTyped(value?: SteamNewsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'url': value['url'],
        'author': value['author'],
        'contents': value['contents'],
        'date': value['date'],
        'feedLabel': value['feedLabel'],
        'imageUrl': value['imageUrl'],
    };
}

